import React from 'react';
import { UpdateForm, UpdateFormProps } from 'framework/form';
import { UpdateTimelineItemLayout } from 'framework/ui/timeline';
import NoteForm from 'domain/recruiting/candidate/Timeline/note/shared/form/NoteForm';

interface UpdateNoteFormProps extends Omit<UpdateFormProps, 'submitFormFunc'> {
  service: () => any;
  onCancel: () => void;
}

const UpdateNoteForm = ({ service, getDataFunc, onCancel, ...props }: UpdateNoteFormProps) => {
  const { getValidationSchema, update } = service();

  return (
    <UpdateForm
      getDataFunc={getDataFunc}
      submitFormFunc={update}
      getValidationSchemaFunc={getValidationSchema}
      {...props}
    >
      <UpdateTimelineItemLayout onCancel={onCancel}>
        <NoteForm />
      </UpdateTimelineItemLayout>
    </UpdateForm>
  );
};

export default UpdateNoteForm;
